import { StyleSheet, View } from '@react-pdf/renderer'
import React from 'react'
import { ErrorBoundary } from '../../error-boundary'
import H3 from './H3'
import Paragraph from './Paragraph'

const styles = StyleSheet.create({
	listItem: {
		fontFamily: `Inter`,
		fontSize: 9,
		lineHeight: 1.3,
		flexDirection: `row`,
		paddingRight: 20,
	},
	listItemColumn: {
		width: 10,
		maxWidth: 10,
		marginRight: 4,
		alignItems: `flex-start`,
		justifyContent: `flex-start`,
	},
})

const ListItem = ({ children }: { children: React.ReactNode }) => {
	return (
		<ErrorBoundary message={'Error in ListItem'}>
			<View style={styles?.listItem}>
				<View style={styles?.listItemColumn}>
					<H3>•</H3>
				</View>
				<Paragraph>{children}</Paragraph>
			</View>
		</ErrorBoundary>
	)
}

export default ListItem
